import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const VisitFormPage = lazy(() => import("@/pages/VisitForm/VisitFormPage"));
const VisitForm = lazy(() => import("@/pages/VisitForm/VisitForm"));
const AddVisitForm = lazy(()=>import("@/pages/VisitForm/AddForm/AddForm"));
const VisitDetail = lazy(()=>import("@/pages/VisitForm/VisitFormDetail/VisitFormDetail"));

const DynamicFormRoute: RouteConfig = {
    path: "/dynamicform",
    element: <VisitForm />,
    pageName: "Dynamic Form",
    sidebar: { show: true, icon: "/assets/media/dynamicFormLogo.svg" },
    permission: ["DynamicFormView"],
    children: {
        MAIN: {
            path: "",
            element: <VisitFormPage />,
            pageName: "Dynamic Form",
            permission: ["DynamicFormView"],
            sidebar: { show: false },
        },
        ADD_FORM :{
            path: "addform",
            element: <AddVisitForm />,
            pageName: "Dynamic Form",
            permission: ["VisitFormAdd"],
            sidebar: { show: false },
        },
        VIEW_DETAIL:{
            path: "viewdetail",
            element: <VisitDetail />,
            pageName: "Dynamic Form",
            sidebar: { show: false },
        }

    }
}

export default DynamicFormRoute;

